import { defineMessages } from 'react-intl';

const messages = defineMessages({
  unitAffordableSetup: {
    id: 'App.ViewUnit.UnitAffordableSetup.unitAffordableSetup',
    defaultMessage: 'Unit Affordable Setup',
  },
  hudUnitNumberTooltip: {
    id: 'App.ViewUnit.UnitAffordableSetup.hudUnitNumberTooltip',
    defaultMessage:
      'If the Fortress Unit # differs from the HUD contract Unit #, ' +
      'please enter it here to ensure your Voucher sends the HUD Unit # to TRACS.',
  },
  affordableProgram: {
    id: 'App.ViewUnit.UnitAffordableSetup.affordableProgram',
    defaultMessage: 'Affordable Program',
  },
  hud: {
    id: 'App.ViewUnit.UnitAffordableSetup.hud',
    defaultMessage: 'HUD',
  },
  hudSubsidyType: {
    id: 'App.ViewUnit.UnitAffordableSetup.hudSubsidyType',
    defaultMessage: 'HUD Subsidy Type',
  },
  hudSubsidyTypeTooltip: {
    id: 'App.ViewUnit.UnitAffordableSetup.hudSubsidyTypeTooltip',
    defaultMessage:
      'Subsidy Type options include the Contract #. This is to ensure the correct Contract # is tied to this unit.',
  },
  hudContractNumber: {
    id: 'App.ViewUnit.UnitAffordableSetup.hudContractNumber',
    defaultMessage: 'HUD Contract #',
  },
  hudContractNumberTooltip: {
    id: 'App.ViewUnit.UnitAffordableSetup.hudContractNumberTooltip',
    defaultMessage:
      'This is the HUD Contract # assigned to the HUD Subsidy type.',
  },
  unitAbatementStatus: {
    id: 'App.ViewUnit.UnitAffordableSetup.unitAbatementStatus',
    defaultMessage: 'Abatement Status',
  },
  notAbated: {
    id: 'App.ViewUnit.UnitAffordableSetup.notAbated',
    defaultMessage: 'Not Abated',
  },
  currentlyAbated: {
    id: 'App.ViewUnit.UnitAffordableSetup.currentlyAbated',
    defaultMessage: 'Currently Abated',
  },
  unitAbatementStartDate: {
    id: 'App.ViewUnit.UnitAffordableSetup.unitAbatementStartDate',
    defaultMessage: 'Abatement Start Date',
  },
  unitAbatementEndDate: {
    id: 'App.ViewUnit.UnitAffordableSetup.unitAbatementEndDate',
    defaultMessage: 'Abatement End Date',
  },
  hudUnitNumber: {
    id: 'App.ViewUnit.UnitAffordableSetup.hudUnitNumber',
    defaultMessage: 'HUD Unit #',
  },
  save: {
    id: 'App.ViewUnit.UnitAffordableSetup.save',
    defaultMessage: 'Save',
  },
  edit: {
    id: 'App.ViewUnit.UnitAffordableSetup.edit',
    defaultMessage: 'Edit',
  },
  updateUnitSuccess: {
    id: 'App.ViewUnit.UnitAffordableSetup.updateUnitSuccess',
    defaultMessage: 'Unit updated successfully',
  },
  updateUnitError: {
    id: 'App.ViewUnit.UnitAffordableSetup.updateUnitError',
    defaultMessage: 'Failed to update unit',
  },
  hudContractsLoadError: {
    id: 'App.ViewUnit.UnitAffordableSetup.hudContractsLoadError',
    defaultMessage: 'Failed to load HUD contracts',
  },
  phProjectLoadError: {
    id: 'App.ViewUnit.UnitAffordableSetup.phProjectLoadError',
    defaultMessage: 'Failed to load PH project assignment',
  },
  phProjectNumberSuffix: {
    id: 'App.ViewUnit.UnitAffordableSetup.phProjectNumberSuffix',
    defaultMessage: 'Project Number & Suffix',
  },
  publicHousing: {
    id: 'App.ViewUnit.UnitAffordableSetup.publicHousing',
    defaultMessage: 'Public Housing',
  },
  lihtc: {
    id: 'App.ViewUnit.UnitAffordableSetup.lihtc',
    defaultMessage: 'LIHTC',
  },
  home: {
    id: 'App.ViewUnit.UnitAffordableSetup.home',
    defaultMessage: 'HOME',
  },
  bond: {
    id: 'App.ViewUnit.UnitAffordableSetup.bond',
    defaultMessage: 'BOND',
  },
  phUnitNumber: {
    id: 'App.ViewUnit.UnitAffordableSetup.phUnitNumber',
    defaultMessage: 'PH Unit Number',
  },
  setAside: {
    id: 'App.ViewUnit.UnitAffordableSetup.setAside',
    defaultMessage: 'Set Aside',
  },
  xmlUnitNumber: {
    id: 'App.ViewUnit.UnitAffordableSetup.xmlUnitNumber',
    defaultMessage: 'Alternative Unit Name (XML)',
  },
  homeFixedOrFloating: {
    id: 'App.ViewUnit.UnitAffordableSetup.homeFixedOrFloating',
    defaultMessage: 'Fixed or Floating',
  },
  noEditableFieldsTooltip: {
    id: 'App.ViewUnit.UnitAffordableSetup.noEditableFieldsTooltip',
    defaultMessage:
      'There are no available edits that can be made for this program.',
  },
});

export default messages;
